import React,{useEffect,useState} from 'react';
import {Analytics} from '@vercel/analytics/react';
const key='technoration-cookie-choice';
export default function CookieConsent(){
  const [choice,setChoice]=useState(()=>localStorage.getItem(key));
  useEffect(()=>{
    window.gtag?.('consent','update',{analytics_storage:choice==='accepted'?'granted':'denied'});
  },[choice]);
  if(choice) return choice==='accepted' ? <Analytics/> : null;
  const choose=value=>{localStorage.setItem(key,value);setChoice(value);if(value==='accepted')window.location.reload()};
  return <div className="cookie-banner" role="region" aria-label="Cookie preferences"><p>We use optional analytics and chat tools. You can accept or decline. See our <a href="/cookies">cookie policy</a>.</p><div><button className="button button-outline" onClick={()=>choose('declined')}>Decline</button><button className="button button-primary" onClick={()=>choose('accepted')}>Accept optional tools</button></div></div>;
}
